import {Auth} from 'aws-amplify';
import LogRocket from 'logrocket';

import i18n from '@/i18n.ts';

export const signIn = async ({commit, dispatch}: any, {username, password}: any) => {
  try {
    commit('setUsername', username);
    const res = await Auth.signIn(username, password);
    if (res.challengeName) {
      throw ({
        code: 'NEW_PASSWORD_REQUIRED',
        message: i18n.t('auth.newPassword.alert'),
      });
    }
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    if (err.code) {
      commit('setChallenge', err.code);
    }
    return false;
  }
};
// @ts-ignore
export const completeNewPassword = async ({dispatch}, {username, password, newPassword}) => {
  try {
    username = username.toLowerCase();
    const user = await Auth.signIn(username, password);
    await Auth.completeNewPassword(user, newPassword, {});
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const signUp = async ({commit, dispatch}, {username, password}) => {
  try {
    username = username.toLowerCase();
    commit('setUsername', username);
    commit('setPassword', password);
    await Auth.signUp({username, password, attributes: {email: username}});
    return true;
  } catch (err) {
    // TODO: save error code somewhere in state
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const confirmSignUp = async ({dispatch}, {username, code}) => {
  try {
    username = username.toLowerCase();
    await Auth.confirmSignUp(username, code);
    dispatch('common/snackbar/success', 'User confirmed!', {root: true});
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const resendSignUp = async ({dispatch}, {username}) => {
  try {
    username = username.toLowerCase();
    await Auth.resendSignUp(username);
    dispatch('common/snackbar/success', i18n.t('auth.resendCodeSuccess'), {root: true});
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const signOut = async ({dispatch}) => {
  try {
    dispatch('common/ui/setSidebar', false, {root: true});
    await Auth.signOut();
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const changePassword = async ({dispatch}, {oldPassword, newPassword}) => {
  try {
    await Auth.currentAuthenticatedUser()
      .then((user) => Auth.changePassword(user, oldPassword, newPassword));
    dispatch('common/snackbar/success', i18n.t('auth.changePasswordSuccess'), {root: true});
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const forgotPassword = async ({commit, dispatch}, {username}) => {
  try {
    username = username.toLowerCase();
    commit('setUsername', username);
    await Auth.forgotPassword(username);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const forgotPasswordSubmit = async ({dispatch}, {username, code, newPassword}) => {
  try {
    username = username.toLowerCase();
    await Auth.forgotPasswordSubmit(username, code, newPassword);
    dispatch('common/snackbar/success', i18n.t('auth.changePasswordSuccess'), {root: true});
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    return false;
  }
};
// @ts-ignore
export const loadUser = async ({dispatch}) => {
  try {
    await Auth.currentSession().then((user) => {
      LogRocket.init('h75am5/robinhood-english');
      LogRocket.identify(user.getIdToken().payload.sub, {
        name: user.getIdToken().payload['cognito:username'],
        email: user.getIdToken().payload.email,
      });
    });
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, {root: true});
    dispatch('common/loader/removeLoader', {}, {root: true});
    return false;
  }
};
